// Parse a comma-separated FGID input into numbers, dropping blanks and
// non-numeric entries.
export function parseFgids(input: string): number[] {
  return input
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .map(Number)
    .filter((n) => Number.isInteger(n) && n > 0);
}

// Parse comma-separated Site IDs, uppercased, dropping blanks.
export function parseSiteIds(input: string): string[] {
  return input
    .split(',')
    .map((s) => s.trim().toUpperCase())
    .filter(Boolean);
}
